import React from 'react';
import { StarProps } from './types';

const StarSymbol = ({ greenPercentage }: StarProps) => {
  const starStyle = {
    background: `linear-gradient(90deg, rgba(0,184,116,255) ${greenPercentage}%, black ${100 - greenPercentage}%)`,
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    display: 'inline-block',
    fontSize: '24px',
  };

  const starSymbol = '\u2605';

  return <div style={starStyle}>{starSymbol}</div>;
};

export default StarSymbol;
